/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { SmsTemplateDetailsDto, SmsTemplateListItemDto } from './sms-templates.dto';

export const SmsTemplateListItemMapper = entity<SmsTemplateListItemDto>({});
export const SmsTemplateDetailsMapper = entity<SmsTemplateDetailsDto>({});
